module.exports = __webpack_public_path__ + "img/rectangle-gray.ccc84133.svg";